import { create } from "zustand";
import { api, ApiError } from "@/lib/api.js";

type AuthUser = { id: string; email: string };

type AuthStore = {
  user: AuthUser | null;
  checked: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  checkSession: () => Promise<void>;
};

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  checked: false,

  login: async (email, password) => {
    const res = await api.post<{ ok: boolean; user: AuthUser }>(
      "/api/auth/login/super-admin",
      { email, password }
    );
    set({ user: res.user });
  },

  logout: async () => {
    await api.post("/api/auth/logout").catch(() => {});
    set({ user: null });
  },

  checkSession: async () => {
    try {
      const res = await api.get<{ authenticated: boolean; user?: AuthUser; user_type?: string }>(
        "/api/auth/session"
      );
      const isSuperAdmin = res.authenticated && res.user_type === "super_admin";
      set({ user: isSuperAdmin ? (res.user ?? null) : null, checked: true });
    } catch (e) {
      if (e instanceof ApiError) set({ user: null, checked: true });
      else set({ checked: true });
    }
  },
}));
